document.addEventListener('alpine:init', () => {
  Alpine.store('variantMultiSelect', {
    selectedVariantsArray: [], // Contains all selected variants and its data
    selectedQuantity: 0, // Set the limit of variants to be added at once
    remainingSelectedQuantity: 0, // Watches the number of quantity left (selectedQuantity - currentSelectedVariantQuantity)
    currentSelectedVariantQuantity: 0, // Watches the current selected variants quantity
    selectedQuantityWords: "Zero", // Convert number into number's word
    variantOptionsState: false, // Set if variant options can be selected
    selectedVariantsTotalPrice: 0, // Total price of the selected variants
    selectedVariantSize: "", // Current selected variant size name
    variantOptionContainer: "", // Variant option element container,
    dynamicFeaturedImageContainer: "",
    dynamicPricesContainer: "",
    dynamicFeaturedBefore: "",
    dynamicFeaturedAfter: "",
    discount: "",
    discountValue: "",
    resetTrigger: false,

    init() {
      this.setSelectedQuantity(1)
    },

    setSelectedQuantity(value) {
      this.selectedQuantity = value
      this.remainingSelectedQuantity = this.selectedQuantity
      this.convertNumberIntoWords(this.selectedQuantity - 1)
    },

    setQuantityLimitResetSelections(limit) {
      this.setSelectedQuantity(limit)
      this.resetAll()
    },

    setVariantOptionsState() {
      this.remainingSelectedQuantity === 0 ? this.variantOptionsState = true : this.variantOptionsState = false
      this.calculateTotalPrice()
    },

    addVariant(product) {
      const duplicateProductItem = this.selectedVariantsArray.findIndex(item => item.id === product.id)
      if (duplicateProductItem !== -1) {
        this.selectedVariantsArray.splice(duplicateProductItem, 1)
      }

      this.selectedVariantsArray.push(product)
    },

    removeVariant(productId) {
      const duplicateProductItem = this.selectedVariantsArray.findIndex(item => item.id === productId)
      if (duplicateProductItem !== -1) { // Only remove if the product is found
        this.selectedVariantsArray.splice(duplicateProductItem, 1);
      }
    },

    setVariantSize(element) {
      this.selectedVariantSize = element.value
      this.setQuantityLimitResetSelections(this.selectedQuantity)

      let variantPrice = Alpine.store('methods').formatMoney(Number(element.dataset.price))
      let variantDiscountedPrice = Alpine.store('methods').formatMoney(Number(element.dataset.discounted))

      this.dynamicPricesContainer.children[0].innerHTML = variantPrice
      this.dynamicPricesContainer.children[1].innerHTML = variantDiscountedPrice
      this.clickAddedVariant();
    },

    getMatchVariant(color) {
      const variantsData = JSON.parse(document.querySelector(".variant-selector__variants-json[type='application/json']").text) || []
      return variantsData.filter(variant => variant.option1 === color && variant.option2 === this.selectedVariantSize)
    },

    resetSelectedVariants() {
      let activeVariantOptions = Array.from(this.variantOptionContainer.querySelectorAll(".relative")).filter(option =>
        option.querySelector(".multi-select-option").dataset.counter >= 1)

      if (activeVariantOptions.length === 0) return
      activeVariantOptions.forEach(activeOption => {
        activeOption.querySelector(".multi-select-option").setAttribute('data-counter', 0)
        activeOption.querySelector(".multi-select-option").classList.remove('is-selected')
      })
    },

    resetAll() {
      this.selectedVariantsArray = []
      this.currentSelectedVariantQuantity = 0
      this.variantOptionsState = false
      this.selectedVariantsTotalPrice = 0
      this.resetSelectedVariants()
      this.resetQuantities();
    },

    resetQuantities() {
      this.resetTrigger = !this.resetTrigger; // Toggle to trigger reset in all instances
    },

    clickAddedVariant() {
      const selectedColor = document.querySelector(".multi-select-option.is-active");
      if(!selectedColor) return;
      selectedColor.click();
    },

    calculateTotalPrice() {
      if (!this.selectedVariantsArray) return
      let totalPrice = 0

      this.selectedVariantsArray.map(product => {
        const discount = product.price * (product.discount / 100);
        const equation = product.discount ? (product.price - discount) * product.quantity
          : product.price * product.quantity;
        return totalPrice += equation
      })

      this.selectedVariantsTotalPrice = Alpine.store('methods').formatMoney(totalPrice)
    },

    convertNumberIntoWords(number) {
      const words = ["One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten"]
      this.selectedQuantityWords = words[number]
    },

    customAddToCart() {
      if (!this.selectedVariantsArray) return
      window.CartJS.addItems(this.selectedVariantsArray)
    }
  })

  Alpine.data('ProductTopItem', () => ({
    setCustomQuantity(element) {
      let customQuantity = Number(element.dataset.quantity)
      Alpine.store('variantMultiSelect').setQuantityLimitResetSelections(customQuantity)
      Alpine.store('variantMultiSelect').clickAddedVariant()
    },

    setDiscount(element) {
      Alpine.store('variantMultiSelect').discount = element.getAttribute("data-discount-message");
      Alpine.store('variantMultiSelect').discountValue = parseFloat(element.getAttribute("data-discount"));
    },

    increaseCustomQuantity(inputQuantity) {
      let inputQuantityValue = Number(inputQuantity.value)
      inputQuantityValue++
      Alpine.store('variantMultiSelect').setQuantityLimitResetSelections(inputQuantityValue)
      Alpine.store('variantMultiSelect').clickAddedVariant();
    },

    decreaseCustomQuantity(inputQuantity) {
      let inputQuantityValue = Number(inputQuantity.value)
      inputQuantityValue--
      Alpine.store('variantMultiSelect').setQuantityLimitResetSelections(inputQuantityValue)
      Alpine.store('variantMultiSelect').clickAddedVariant();
    }
  }))

  Alpine.data('VariantOption', () => ({
    setVariantQuantity: 0,

    init() {
      this.$nextTick(() => {
        if(!this.$refs.firstVariant) return;
        this.$refs.firstVariant.click()
      });
    },

    previewVariantImage(element) {
      if(!event.isTrusted) return;
      let variantName = String(element.dataset.name), variantCounter = Number(element.dataset.counter)
      const getVariantFeaturedImage = Alpine.store('variantMultiSelect').getMatchVariant(variantName)[0].featured_image.src
      const active = document.querySelector(".multi-select-option.is-active");
      const videos = document.querySelectorAll("#main-slider .mfr-components__video");

      for(let i = 0; i < videos.length; i++) {
        videos[i].remove();
      }

      if (active) active.classList.remove('is-active');
      element.classList.add('is-active')
      Alpine.store('variantMultiSelect').dynamicFeaturedImageContainer.parentElement.style.display = "";
      Alpine.store('variantMultiSelect').dynamicFeaturedImageContainer.classList.remove('has-shadow')
      Alpine.store('variantMultiSelect').dynamicFeaturedImageContainer.classList.remove('preview-media')
      Alpine.store('variantMultiSelect').dynamicFeaturedImageContainer.closest('.product-top__featured-image').classList.remove("preview-gallery")
      Alpine.store('variantMultiSelect').dynamicFeaturedImageContainer.innerHTML = `<img src="${getVariantFeaturedImage}" alt="${variantName}" loading="lazy" class="variant-featured-image image-contain" />`
    },

    addVariantIntoSelection(element) {
      element = element.closest(".relative").querySelector(".multi-select-option");
      let variantName = String(element.dataset.name), variantCounter = Number(element.dataset.counter)

      if (!Alpine.store('variantMultiSelect').getMatchVariant(variantName) || variantCounter === 1) return

      let { id, price, } = Alpine.store('variantMultiSelect').getMatchVariant(variantName)[0]

      Alpine.store('variantMultiSelect').setQuantityLimitResetSelections(Alpine.store('variantMultiSelect').selectedQuantity)

      element.setAttribute('data-counter', Alpine.store('variantMultiSelect').selectedQuantity)
      element.classList.add('is-selected')

      Alpine.store('variantMultiSelect').currentSelectedVariantQuantity = Alpine.store('variantMultiSelect').currentSelectedVariantQuantity + Alpine.store('variantMultiSelect').selectedQuantity
      Alpine.store('variantMultiSelect').remainingSelectedQuantity = Alpine.store('variantMultiSelect').selectedQuantity - Alpine.store('variantMultiSelect').currentSelectedVariantQuantity
      Alpine.store('variantMultiSelect').convertNumberIntoWords(Alpine.store('variantMultiSelect').remainingSelectedQuantity - 1)
      Alpine.store('variantMultiSelect').addVariant({ id: id, title: variantName, price: price, discount: Alpine.store('variantMultiSelect').discountValue, quantity: Alpine.store('variantMultiSelect').selectedQuantity })
      Alpine.store('variantMultiSelect').setVariantOptionsState();
    }
  }))
})